import { render, staticRenderFns } from "./Privacy.html?vue&type=template&id=e80a25f8&scoped=true&"
import script from "./Privacy.ts?vue&type=script&lang=ts&"
export * from "./Privacy.ts?vue&type=script&lang=ts&"
import style0 from "./Privacy.css?vue&type=style&index=0&id=e80a25f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a25f8",
  null
  
)

export default component.exports